import { useSearchParams } from "react-router-dom";
import { BrandLockup } from "@/components/Branding";
import { ProtectDiary } from "@/components/diary/ProtectDiary";

export default function AccountAccess() {
  const [params] = useSearchParams();
  const mode = params.get("mode") === "create" ? "create" : "signin";

  return (
    <div data-testid="account-access-page" className="flex min-h-screen flex-col bg-[#FAF6F0]">
      <header className="mx-auto flex w-full max-w-6xl items-center justify-center gap-3 px-4 py-4 sm:px-6">
        <BrandLockup />
      </header>
      <main className="flex-1 px-1 pt-4 sm:pt-10">
        <div className="mx-auto mb-6 max-w-md px-4 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#36858B]">Your private diary</p>
          <h1 className="mt-2 font-serif text-3xl text-[#2D2824] sm:text-4xl">Welcome to your life journey</h1>
          <p className="mt-2 text-sm leading-relaxed text-[#6E665E]">Sign in to continue, or create an account to begin your free Childhood journey.</p>
        </div>
        <ProtectDiary initialMode={mode} />
      </main>
    </div>
  );
}
